import { ModerationLayout } from 'layouts/ModerationLayout/ModerationLayout';
import ChannelsViolationsPage from 'pages/Moderation/ChannelsViolationsPage/ChannelsViolationsPage';
import BlockedEntitiesPage from 'pages/Moderation/BlockedEntities/BlockedEntitiesPage';
import { ChannelViolationsDetailsPage } from 'pages/Moderation/ChannelViolationsDetailsPage/ChannelViolationsDetailsPage';
import { ModerationDashboardPage } from 'pages/Moderation/ModerationDashboard/ModerationDashboardPage';
import ModerationQueuePage from 'pages/Moderation/ModerationQueue/ModerationQueuePage';
import ModerationQueueDetailsPage from 'pages/Moderation/ModerationQueueDetailsPage/ModerationQueueDetailsPage';
import UsersViolationsPage from 'pages/Moderation/UsersViolationsPage/UsersViolationsPage';
import { UserViolationsDetailsPage } from 'pages/Moderation/UserViolationsDetailsPage/UserViolationsDetailsPage';
import { Navigate } from 'react-router-dom';
import { ELinksName } from 'services/constants/list-links-sidebar';
import ErrorRoutes from './ErrorRoutes';

export const base = `/${ELinksName.MODERATION}`; // => '/moderation'

const ModerationRoutes = {
  path: base,
  element: <ModerationLayout />,
  children: [
    // /moderation  ->  /moderation/dashboard
    { index: true, element: <Navigate to="dashboard" replace /> },

    { path: 'dashboard/:tab?', element: <ModerationDashboardPage /> },
    { path: 'queue/:tab?', element: <ModerationQueuePage /> },
    { path: 'details-queue/:id', element: <ModerationQueueDetailsPage /> },
    { path: 'users', element: <UsersViolationsPage /> },
    { path: 'channels', element: <ChannelsViolationsPage /> },
    { path: 'blocked/:tab?', element: <BlockedEntitiesPage /> },
    { path: 'channel/violations/:id', element: <ChannelViolationsDetailsPage /> },
    { path: 'user/violations/:id', element: <UserViolationsDetailsPage /> },
    // { path: 'reports', element: <ModerationReports /> },
    // { path: 'analytics', element: <ModerationAnalytics /> },
    // { path: 'settings', element: <ModerationSetings /> },
    // { path: 'moderators', element: <ModerationModerators /> },
    ErrorRoutes,
  ],
};

export default ModerationRoutes;
